var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "brief-panel",
      class: {
        "brief-panel--linked": _vm.currentBrief && !_vm.isSelectingBrief,
      },
    },
    [
      !_vm.currentBrief || _vm.isSelectingBrief
        ? [
            _c("div", { staticClass: "brief-panel__header" }, [
              _c("div", { staticClass: "brief-panel__title-row" }, [
                _c(
                  "svg",
                  {
                    staticClass: "brief-panel__title-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.75",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        width: "8",
                        height: "4",
                        x: "8",
                        y: "2",
                        rx: "1",
                        ry: "1",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M12 11h4" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M12 16h4" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M8 11h.01" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M8 16h.01" } }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "brief-panel__title-text" }, [
                  _vm._v("Brief"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "brief-panel__body" }, [
              _c("div", { staticClass: "brief-panel__action-row" }, [
                _c("span", [_vm._v("Select a brief to link it")]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "brief-panel__new-brief",
                    attrs: {
                      href: "/briefs",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M5 12h14" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M12 5v14" } }),
                      ]
                    ),
                    _vm._v("\n          New brief\n        "),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brief-panel__search" }, [
                _c(
                  "svg",
                  {
                    staticClass: "brief-panel__search-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "m21 21-4.3-4.3" } }),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.search,
                      expression: "search",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "brief-panel__search-input",
                  attrs: { type: "text", placeholder: "Search briefs" },
                  domProps: { value: _vm.search },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.search = $event.target.value.trim()
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brief-panel__list-wrap" }, [
                _c(
                  "div",
                  { staticClass: "brief-panel__list" },
                  [
                    _vm.isLoading
                      ? _c("div", { staticClass: "brief-panel__state" }, [
                          _vm._v("\n            Loading briefs…\n          "),
                        ])
                      : _vm.filteredBriefs.length === 0
                      ? _c("div", { staticClass: "brief-panel__state" }, [
                          _vm._v("\n            No briefs found.\n          "),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filteredBriefs, function (brief) {
                      return _c(
                        "button",
                        {
                          key: brief.id,
                          staticClass: "brief-panel__list-item",
                          attrs: { type: "button", disabled: _vm.isSaving },
                          on: {
                            click: function ($event) {
                              return _vm.selectBrief(brief)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "brief-panel__list-title" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(brief.title || "Untitled brief") +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "brief-panel__list-meta" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.briefOwnerLabel(brief)) +
                                " · " +
                                _vm._s(_vm.formatStatusLower(brief.status)) +
                                "\n            "
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]
        : [
            _c("div", { staticClass: "brief-panel__linked-header" }, [
              _c("div", { staticClass: "brief-panel__title-row" }, [
                _c(
                  "svg",
                  {
                    staticClass: "brief-panel__title-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.75",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("rect", {
                      attrs: {
                        width: "8",
                        height: "4",
                        x: "8",
                        y: "2",
                        rx: "1",
                        ry: "1",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M12 11h4" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M12 16h4" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M8 11h.01" } }),
                    _vm._v(" "),
                    _c("path", { attrs: { d: "M8 16h.01" } }),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "brief-panel__title-text" }, [
                  _vm._v("Brief"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "brief-panel__linked-actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "brief-panel__open-link",
                    attrs: {
                      href: _vm.briefUrl(_vm.currentBrief),
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "14",
                          height: "14",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.75",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M15 3h6v6" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "M10 14 21 3" } }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
                          },
                        }),
                      ]
                    ),
                    _vm._v("\n          Open full brief\n        "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "brief-panel__menu",
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        $event.stopPropagation()
                        _vm.menuOpen = false
                      },
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "brief-panel__menu-trigger",
                        attrs: {
                          type: "button",
                          "aria-label": "Brief actions",
                          "aria-haspopup": "menu",
                          "aria-expanded": _vm.menuOpen ? "true" : "false",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.menuOpen = !_vm.menuOpen
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: { cx: "12", cy: "12", r: "1" },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: { cx: "19", cy: "12", r: "1" },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: { cx: "5", cy: "12", r: "1" },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.menuOpen
                      ? _c(
                          "div",
                          {
                            staticClass: "brief-panel__menu-dropdown",
                            attrs: { role: "menu" },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "brief-panel__menu-item",
                                attrs: { type: "button", role: "menuitem" },
                                on: { click: _vm.onChangeBrief },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: { d: "M9 17H7A5 5 0 0 1 7 7h2" },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: { d: "M15 7h2a5 5 0 1 1 0 10h-2" },
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "8",
                                        x2: "16",
                                        y1: "12",
                                        y2: "12",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n              Change brief…\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "brief-panel__menu-divider",
                              attrs: { role: "separator" },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "brief-panel__menu-item brief-panel__menu-item--danger",
                                attrs: { type: "button", role: "menuitem" },
                                on: { click: _vm.onUnlinkBrief },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      width: "14",
                                      height: "14",
                                      viewBox: "0 0 24 24",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "aria-hidden": "true",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "8",
                                        x2: "8",
                                        y1: "2",
                                        y2: "5",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "2",
                                        x2: "5",
                                        y1: "8",
                                        y2: "8",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "16",
                                        x2: "16",
                                        y1: "19",
                                        y2: "22",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("line", {
                                      attrs: {
                                        x1: "19",
                                        x2: "22",
                                        y1: "16",
                                        y2: "16",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n              Unlink brief\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("BriefContentPanel", {
              attrs: {
                brief: _vm.currentBrief,
                variant: "sidebar",
                "show-meta": "",
                "owner-source": "viewer",
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }